export default {
  // AppDetailViewer
  modalStartTest: {
    title: "See Demo of Your Channel",
    content:
      "Your channel is available for demo in the AdviceCoach app on your mobile device. It is in private mode and will not be available to the public. In demo mode, please review your copy and video placement.  When you are ready, return to your site and Publish your channel!",
  },
  modalPublish: {
    title: "Publish Your Channel",
    content:
      "To publish your channel, please contact us at info@advicecoach.com. We have multiple publish plans to suit your use case.",
  },
  // updateAppInfo
  modalUpdateAppInfo: {
    title: "To See the Changes on Your Mobile App",
    content:
      "Please click 'Demo Mode' on My Channels screen of your mobile app to see the changes. If you made change to Logo Image or Action Code, you will also need to click 'Update Channel' inside of the Channel.",
  },
  // updateAppTemplate
  modalUpdateAppTemplate: {
    title: "Changes saved successfully",
    content:
      "Your new library instructions are now available to assign to care plans.",
  },
};



// WEBPACK FOOTER //
// ./src/documents/info.js